<template>
  <div class="daily-deal">
    <!-- 顶部 banner -->
    <div class="deal-banner">
      <div class="banner-rays"></div>
      <div class="banner-content">
        <!-- <span class="banner-text">每日特惠</span>
        <span class="banner-clock">⏰</span>
        <span class="banner-text">限时疯抢</span> -->
        <img src="https://bank.giftoceanmall.com/a520c202609091501183387.png" alt="" />
      </div>
      
      <div class="banner-tip">每日 10:00 开抢 · 24:00 结束</div>
    </div>

    <!-- 面板：Tab + 商品列表 -->
    <div class="deal-panel">
      <div class="tabs">
        <div class="tab" :class="{ active: activeTab === 'today' }" @click="switchTab('today')">
          <div class="tab-name">今日特惠</div>
          <div class="tab-sub">
            <span class="sub-label">{{ countdownLabel }}</span>
            <span class="time-box">{{ countdown.h }}</span>
            <span class="time-box">{{ countdown.m }}</span>
            <span class="time-box">{{ countdown.s }}</span>
          </div>
        </div>
        <div class="tab" :class="{ active: activeTab === 'tomorrow' }" @click="switchTab('tomorrow')">
          <div class="tab-name">明日10点</div>
          <div class="tab-sub sub-warm">准备开抢</div>
        </div>
      </div>

      <div class="goods-list">
        <div
          class="goods-card"
          v-for="item in goodsList"
          :key="activeTab + '-' + item.id"
          @click.stop="onBuy(item)"
        >
          <div class="goods-img">
            <img v-lazy="item.image" :alt="item.store_name" />
          </div>
          <div class="goods-info">
            <div class="goods-name">{{ item.store_name }}</div>
            <div class="benefit-tags">
              <span class="tag">积分至高抵{{ (item.price*0.2).toFixed(2) }}元</span>
              <span class="tag" v-if="item.fenqiNum">{{ item.fenqiNum }}期免息</span>
              <span class="tag">限量100件</span>
            </div>
            <div class="goods-bottom">
              <div class="price-col">
                <div class="origin-price">优惠前&nbsp;<s>¥{{ item.ot_price }}</s></div>
                <div class="deal-price">
                  <span class="price-num">{{ item.finalPrice }}</span><span class="price-unit">元</span>
                  <!-- <span class="price-label">最低到手价</span> -->
                </div>
              </div>
              <div
                class="buy-btn"
                :class="{ disabled: activeTab === 'tomorrow' }"
                
              >
                <span class="lightning">⚡</span>
                <span class="buy-text">{{ activeTab === 'tomorrow' ? '明日开抢' : '抢购' }}</span>
              </div>
            </div>
            <!-- <div class="w_price">
              <div class="pri">
                <div>到手价</div>
                <div>￥{{item.price}}</div>
              </div>
              <div class="fenqi">
                <span style="font-size: 12px;font-weight: bold;">￥</span>
                <span style="font-size: 18px;font-weight: bold;">{{(item.price/12).toFixed(2)}}</span>
                <span style="font-size: 12px;">*12期</span>

              </div>
            </div> -->
          </div>
        </div>
      </div>
    </div>

    <!-- 回到顶部 -->
    <div class="back-top" v-show="showBackTop" @click="toTop">
      <div class="bt-arrow">↑</div>
      <div class="bt-text">顶部</div>
    </div>
  </div>
</template>

<script>
import { goShopDetail } from "@libs/order";
import { getProductClassCollection } from "@api/store";

// 每日特惠商品合集ID（后台配置合集后替换为对应ID）
const TODAY_COLLECTION_ID = 41; // 今日特惠
const TOMORROW_COLLECTION_ID = 42; // 明日预告

export default {
  name: "Activity11",
  data() {
    return {
      activeTab: "today",
      todayGoods: [],
      tomorrowGoods: [],
      countdown: { h: "00", m: "00", s: "00" },
      countdownLabel: "距结束",
      timer: null,
      showBackTop: false
    };
  },
  computed: {
    goodsList() {
      return this.activeTab === "today" ? this.todayGoods : this.tomorrowGoods;
    }
  },
  mounted() {
    this.getTodayGoods();
    this.getTomorrowGoods();
    this.updateCountdown();
    this.timer = setInterval(this.updateCountdown, 1000);
    window.addEventListener("scroll", this.handleScroll, { passive: true });
  },
  beforeDestroy() {
    if (this.timer) clearInterval(this.timer);
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    // 获取今日特惠商品
    getTodayGoods() {
      getProductClassCollection({ id: TODAY_COLLECTION_ID, page: 1, limit: 99 })
        .then(res => {
          const list = res.data && res.data.list;
          this.todayGoods = list && list.length ? this.formatGoods(list) : this.mockGoods();
        })
        .catch(() => {
          this.todayGoods = this.mockGoods();
        });
    },
    // 获取明日预告商品
    getTomorrowGoods() {
      getProductClassCollection({ id: TOMORROW_COLLECTION_ID, page: 1, limit: 99 })
        .then(res => {
          const list = res.data && res.data.list;
          this.tomorrowGoods = list && list.length ? this.formatGoods(list) : this.mockGoods();
        })
        .catch(() => {
          this.tomorrowGoods = this.mockGoods();
        });
    },
    // 格式化商品利益点
    // 最低到手价 = 售价 - 20%积分抵扣；优先使用后台返回的 final_price / integral_discount / limit_num
    formatGoods(list) {
      return list.map(item => {
        const price = parseFloat(item.price) || 0;
        const integralDiscount =
          item.integral_discount != null && item.integral_discount !== ""
            ? parseFloat(item.integral_discount)
            : Math.round(price * 0.2 * 10) / 10;
        const finalPrice =
          item.final_price != null && item.final_price !== ""
            ? parseFloat(item.final_price)
            : Math.round(price * 0.8 * 10) / 10;
        const limitNum =
          item.limit_num != null && item.limit_num !== "" ? item.limit_num : item.stock;
        return {
          ...item,
          integralDiscount,
          finalPrice,
          limitNum: limitNum != null ? limitNum : null,
          fenqiNum: item.fenqi_num || 0
        };
      });
    },
    // 兜底演示数据（后台合集配置完成前使用）
    mockGoods() {
      return [
        {
          id: "mock-1",
          store_name: "福临门 小榨炒香压榨一级花生油 食用油",
          image:
            "https://trae-api-cn.mchost.guru/api/ide/v1/text_to_image?prompt=A%20bottle%20of%20golden%20peanut%20cooking%20oil%20with%20red%20label%2C%20product%20photography%2C%20white%20background%2C%20e-commerce&image_size=square",
          ot_price: "129.9",
          integralDiscount: 21.8,
          finalPrice: 95.9,
          limitNum: 10,
          fenqiNum: 6
        },
        {
          id: "mock-2",
          store_name: "REVERE精铁锅具三件套+碗2个 家用炒锅汤锅煎锅",
          image:
            "https://trae-api-cn.mchost.guru/api/ide/v1/text_to_image?prompt=Black%20cast%20iron%20cookware%20set%20frying%20pan%20and%20pot%20with%20wooden%20handle%2C%20product%20photography%2C%20white%20background%2C%20e-commerce&image_size=square",
          ot_price: "379",
          integralDiscount: 66.5,
          finalPrice: 150,
          limitNum: 99,
          fenqiNum: 12
        },
        {
          id: "mock-3",
          store_name: "佰草集红茶紧致面霜50g 补水保湿护肤",
          image:
            "https://trae-api-cn.mchost.guru/api/ide/v1/text_to_image?prompt=Red%20jar%20of%20face%20cream%20moisturizer%20skincare%20product%2C%20product%20photography%2C%20white%20background%2C%20e-commerce&image_size=square",
          ot_price: "180",
          integralDiscount: 36.9,
          finalPrice: 69,
          limitNum: 99,
          fenqiNum: 6
        }
      ];
    },
    switchTab(tab) {
      this.activeTab = tab;
    },
    // 倒计时：每日10:00开始，24:00结束
    updateCountdown() {
      const now = new Date();
      let target;
      if (now.getHours() < 10) {
        // 10点前：距今日10点开抢
        target = new Date(now);
        target.setHours(10, 0, 0, 0);
        this.countdownLabel = "距开始";
      } else {
        // 10点后：距当日24点结束
        target = new Date(now);
        target.setHours(24, 0, 0, 0);
        this.countdownLabel = "距结束";
      }
      let diff = Math.max(0, Math.floor((target.getTime() - now.getTime()) / 1000));
      const h = Math.floor(diff / 3600);
      const m = Math.floor((diff % 3600) / 60);
      const s = diff % 60;
      const pad = n => (n < 10 ? "0" + n : "" + n);
      this.countdown = { h: pad(h), m: pad(m), s: pad(s) };
    },
    onBuy(item) {
      if (this.activeTab === "tomorrow") {
        this.$dialog.toast({ mes: "明日10点开抢，敬请期待" });
        return;
      }
      this.goDetail(item.id);
    },
    goDetail(id) {
      goShopDetail(id).then(() => {
        this.$router.push({ path: "/detail/" + id });
      });
    },
    handleScroll() {
      const top = window.scrollY || document.documentElement.scrollTop || document.body.scrollTop || 0;
      this.showBackTop = top > 400;
    },
    toTop() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }
};
</script>

<style scoped lang="scss">
.daily-deal {
  min-height: 100vh;
  background: #f4141f;
  padding-bottom: 0.4rem;
}

/* 顶部 banner */
.deal-banner {
  position: relative;
  width: 100%;
  padding: 0.5rem 0 0.36rem;
  text-align: center;
  overflow: hidden;
  background: linear-gradient(180deg, #ff3b2f 0%, #f4141f 100%);

  .banner-rays {
    position: absolute;
    top: -1.6rem;
    left: 50%;
    width: 9rem;
    height: 9rem;
    transform: translateX(-50%);
    background: repeating-conic-gradient(
      from 0deg,
      rgba(255, 220, 120, 0.18) 0deg 8deg,
      rgba(255, 255, 255, 0) 8deg 16deg
    );
    pointer-events: none;
  }

  .banner-content {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .banner-tip {
    position: relative;
    margin-top: 0.16rem;
    color: #ffe9b8;
    font-size: 0.24rem;
  }
}

/* 面板 */
.deal-panel {
  position: relative;
  margin: 0 0.2rem;
  background: #fff;
  border-radius: 0.2rem;
  overflow: hidden;
}

/* Tab 栏 */
.tabs {
  display: flex;

  .tab {
    flex: 1;
    padding: 0.2rem 0 0.16rem;
    text-align: center;
    background: #fdeee0;

    &.active {
      background: #fff;
    }

    .tab-name {
      font-size: 0.36rem;
      font-weight: bold;
      color: #333;
      line-height: 1.4;
    }

    .tab-sub {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 0.06rem;

      .sub-label {
        font-size: 0.24rem;
        color: #666;
        margin-right: 0.08rem;
      }

      .time-box {
        display: inline-block;
        min-width: 0.4rem;
        padding: 0.02rem 0.06rem;
        margin-right: 0.06rem;
        background: #f4141f;
        color: #fff;
        font-size: 0.26rem;
        font-weight: bold;
        border-radius: 0.06rem;
        line-height: 1.3;

        &:last-child {
          margin-right: 0;
        }
      }

      &.sub-warm {
        color: #b07a55;
        font-size: 0.26rem;
      }
    }
  }
}

/* 商品列表 */
.goods-list {
  background: #fff;
}

.goods-card {
  display: flex;
  padding: 0.24rem 0.2rem;
  border-bottom: 0.1rem solid #f7f7f7;

  &:last-child {
    border-bottom: none;
  }

  .goods-img {
    flex-shrink: 0;
    width: 2.1rem;
    height: 2.1rem;
    margin-right: 0.2rem;
    background: #f7f7f7;
    border-radius: 0.12rem;
    overflow: hidden;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .goods-info {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
  }

  .goods-name {
    font-size: 0.3rem;
    font-weight: bold;
    color: #333;
    line-height: 1.4;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .benefit-tags {
    margin-top: 0.12rem;

    .tag {
      display: inline-block;
    //   padding: 0.03rem 0.12rem;
      margin: 0 0.1rem 0.08rem 0;
      background: #fff3e9;
      color: #ff6a00;
      font-size: 0.22rem;
      border-radius: 0.06rem;
      white-space: nowrap;
    }
  }

  .goods-bottom {
    margin-top: auto;
    display: flex;
    align-items: flex-end;
    justify-content: space-between;

    .price-col {
      min-width: 0;
    }

    .origin-price {
      color: #999;
      font-size: 0.22rem;

      s {
        text-decoration: line-through;
      }
    }

    .deal-price {
      display: flex;
      align-items: baseline;
      margin-top: 0.04rem;

      .price-num {
        color: #f4141f;
        font-size: 0.5rem;
        font-weight: 900;
        line-height: 1;
      }

      .price-unit {
        color: #f4141f;
        font-size: 0.24rem;
        font-weight: bold;
        margin-left: 0.02rem;
      }

      .price-label {
        color: #f4141f;
        font-size: 0.22rem;
        margin-left: 0.12rem;
      }
    }

    .buy-btn {
      position: relative;
      flex-shrink: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 2.1rem;
      height: 0.86rem;
      margin-left: 0.16rem;
      background: #f4141f;
      border-radius: 0.4rem;
      color: #fff;
      box-shadow: 0 0.04rem 0.1rem rgba(244, 20, 31, 0.35);

      .lightning {
        position: absolute;
        top: -0.12rem;
        left: 0.08rem;
        font-size: 0.34rem;
      }

      .buy-text {
        font-size: 0.38rem;
        font-weight: 900;
        font-style: italic;
        margin-left: 0.1rem;
      }

      &.disabled {
        background: #bbb;
        box-shadow: none;

        .lightning {
          display: none;
        }

        .buy-text {
          font-style: normal;
          font-size: 0.3rem;
          margin-left: 0;
        }
      }

      &:active {
        opacity: 0.85;
      }
    }
  }
}

/* 回到顶部 */
.back-top {
  position: fixed;
  right: 0.2rem;
  bottom: 1.2rem;
  width: 0.86rem;
  height: 0.86rem;
  background: #fff;
  border-radius: 0.12rem;
  box-shadow: 0 0.04rem 0.16rem rgba(0, 0, 0, 0.15);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 99;

  .bt-arrow {
    font-size: 0.4rem;
    color: #ff8a00;
    line-height: 1;
  }

  .bt-text {
    font-size: 0.2rem;
    color: #666;
    margin-top: 0.02rem;
  }

  &:active {
    opacity: 0.8;
  }
}
.w_price{
        display: flex;
        width: 210px;
        margin-top: 30px;
        background: url(../../assets/actimg/price.png) no-repeat;
        background-size: 210px;
        height: 43px;
        position: absolute;
        bottom: 10px;
        // margin-left: 10px;
        .pri{
          color: #526079;
          font-size: 11px;
          margin-left: 5px;
          margin-top: 5px;

        }
        .fenqi{
          color: #D73124;
          margin-left: 20px;
          line-height: 43px;
        }
      }
</style>
